module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messaging-sidebar"
  }, [_c('div', {
    staticClass: "messaging-sidebar--dsk"
  }, [(_vm.sidebar === 'no-details') ? _c('div', [_c('a', {
    staticClass: "mr",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.images.arrow,
      "alt": "go back"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.sidebar === 'details') ? _c('div', {
    staticClass: "messaging-sidebar__info"
  }, [_c('a', {
    staticClass: "mr",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.images.arrow,
      "alt": "go back"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "messaging-sidebar__dp",
    attrs: {
      "src": _vm.getSelectedContact.photo_url_absolute,
      "alt": "Provider Photo"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3 mb0"
  }, [_vm._v(_vm._s(_vm.getSelectedContact.fullname))]), _vm._v(" "), _c('p', {
    staticClass: "p m0 small"
  }, [_vm._v(_vm._s(_vm.getSelectedContact.speciality))])]) : _vm._e(), _vm._v(" "), (_vm.sidebar === 'messages') ? _c('div', [_c('ul', _vm._l((_vm.messagesNavItems), function(item, key) {
    return _c('li', {
      key: key,
      class: [
        'mt', 'c-accent', 'cp',
        {
          'fw-bold': item.link === _vm.stage
        }
      ],
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.switchBetween(item.link)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "messaging-sidebar--mbl"
  }, [(_vm.sidebar === 'messages') ? _c('div', [_c('ul', _vm._l((_vm.messagesNavItems), function(item, key) {
    return _c('li', {
      key: key,
      class: [
        'mt', 'c-accent', 'cp', 'fw-bold',
        {
          'visuallyhidden': item.link === _vm.stage,
        }
      ],
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.switchBetween(item.link)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + " "), _c('img', {
      attrs: {
        "src": _vm.images.arrowRight,
        "alt": _vm.stage
      }
    })])
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e662c0f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/MessagingSidebar.vue
// module id = 521
// module chunks = 0